import { useEffect, useState } from "react"
import "./report.css"
import Navbar from "../../components/Navbar"
import { useApi } from "../../hooks/useApi"

const Report = () => {
  const userID = localStorage.getItem("user")
  const { fetchData, isLoading, error } = useApi()
  const [user, setUser] = useState(null)
  const [marks, setMarks] = useState({
    marks_sentence_dictation: 0,
    marks_question_answer: 0,
    marks_storytelling: 0,
    marks_conversation_exchange: 0,
    marks_picture_description: 0,
    marks_comprehension: 0,
  })
  const [lessonTotals, setLessonTotals] = useState({
    SD_total: 0,
    QA_total: 0,
    ST_total: 0,
    PD_total: 0,
    CM_total: 0,
    CE_total: 0,
  })
  const [averageMarks, setAverageMarks] = useState(0)
  const [checkedState, setCheckedState] = useState({
    excellent: false,
    veryGood: false,
    good: false,
    needsImprovement: false,
  })

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const userData = await fetchData(`/profile/${userID}`)
        setUser(userData)

        const [SDdata, QAdata, STdata, CEdata, PDdata, CMdata] = await Promise.all([
          fetchData("/lessons/listening/sentence-dictation"),
          fetchData("/lessons/listening/qa"),
          fetchData("/lessons/speaking/storytelling"),
          fetchData("/lessons/speaking/conversation-exchange"),
          fetchData("/lessons/writing/picturedescription"),
          fetchData("/lessons/reading/comprehension"),
        ])

        setLessonTotals({
          SD_total: SDdata.lessons.length,
          QA_total: QAdata.lessons.length,
          ST_total: STdata.lessons.length,
          CE_total: CEdata.lessons.length,
          PD_total: PDdata.lessons.length,
          CM_total: CMdata.lessons.length,
        })

        const marksData = await fetchData(`/home/get-marks/${userID}`)
        setMarks(marksData)

        const avgMarks = Math.floor(
          (marksData.marks_conversation_exchange +
            marksData.marks_question_answer +
            marksData.marks_comprehension +
            marksData.marks_picture_description +
            marksData.marks_sentence_dictation +
            marksData.marks_storytelling) /
            6,
        )
        setAverageMarks(avgMarks)

        if (avgMarks > 90) {
          setCheckedState({ excellent: true, veryGood: false, good: false, needsImprovement: false })
        } else if (avgMarks > 75) {
          setCheckedState({ excellent: false, veryGood: true, good: false, needsImprovement: false })
        } else if (avgMarks > 60) {
          setCheckedState({ excellent: false, veryGood: false, good: true, needsImprovement: false })
        } else {
          setCheckedState({ excellent: false, veryGood: false, good: false, needsImprovement: true })
        }
      } catch (error) {
        console.error("Error fetching report data:", error)
      }
    }

    fetchReportData()
  }, [userID, fetchData])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  if (!user) {
    return <div>No user data available</div>
  }

  return (
    <div>
      <Navbar />
      <div className="container-report">
        <div className="completions-header">
          <h1>
            Performance <span>Report</span>
          </h1>
        </div>

        <div className="report-table-container">
          <table>
            <thead>
              <tr>
                <th className="th-sl">SL No.</th>
                <th className="th-at">Activity Title</th>
                <th className="th-cat">Category</th>
                <th className="th-ct">Completed Task</th>
                <th className="th-om">Obtained Marks</th>
              </tr>
            </thead>
            <tbody>
              <tr className="row-a">
                <td className="th-sl">1</td>
                <td className="th-at">Sentence Dictation</td>
                <td className="th-cat">Listening Skill</td>
                <td className="th-ct">
                  {user.sentence_dictation}/{lessonTotals.SD_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_sentence_dictation / lessonTotals.SD_total)}</td>
              </tr>
              <tr className="row-b">
                <td className="th-sl">2</td>
                <td className="th-at">Question and Answer</td>
                <td className="th-cat">Listening Skill</td>
                <td className="th-ct">
                  {user.question_answer}/{lessonTotals.QA_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_question_answer / lessonTotals.QA_total)}</td>
              </tr>
              <tr className="row-a">
                <td className="th-sl">3</td>
                <td className="th-at">Storytelling</td>
                <td className="th-cat">Speaking Skill</td>
                <td className="th-ct">
                  {user.storytelling}/{lessonTotals.ST_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_storytelling / lessonTotals.ST_total)}</td>
              </tr>
              <tr className="row-b">
                <td className="th-sl">4</td>
                <td className="th-at">Conversation Exchange</td>
                <td className="th-cat">Speaking Skill</td>
                <td className="th-ct">
                  {user.conversation_exchange}/{lessonTotals.CE_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_conversation_exchange / lessonTotals.CE_total)}</td>
              </tr>
              <tr className="row-a">
                <td className="th-sl">5</td>
                <td className="th-at">Comprehension</td>
                <td className="th-cat">Reading Skill</td>
                <td className="th-ct">
                  {user.comprehension}/{lessonTotals.CM_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_comprehension / lessonTotals.CM_total)}</td>
              </tr>
              <tr className="row-b">
                <td className="th-sl">6</td>
                <td className="th-at">Picture Description</td>
                <td className="th-cat">Writing Skill</td>
                <td className="th-ct">
                  {user.picture_description}/{lessonTotals.PD_total}
                </td>
                <td className="th-om">{Math.floor(marks.marks_picture_description / lessonTotals.PD_total)}</td>
              </tr>
            </tbody>
          </table>
          <table className="feedback-table">
            <tbody>
              <tr>
                <td className="row-first">* Has improved Performance?</td>
                <td>
                  <input type="checkbox" checked disabled /> Yes
                </td>
                <td>
                  <input type="checkbox" disabled /> No
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="row-first">* Performance Quality?</td>
                <td>
                  <input type="checkbox" checked={checkedState.excellent} disabled /> Excellent
                </td>
                <td>
                  <input type="checkbox" checked={checkedState.veryGood} disabled /> Very Good
                </td>
                <td>
                  <input type="checkbox" checked={checkedState.good} disabled /> Good
                </td>
                <td>
                  <input type="checkbox" checked={checkedState.needsImprovement} disabled /> Needs Improvement
                </td>
              </tr>
            </tbody>
          </table>
          <div className="teachers-comment">
            <span>Teacher's comment: </span>
            <p>No comment yet.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Report

